import React from "react";
import { Gallery } from "../components/Gallery";
import {
  Rabbit,
  Zap,
  Waves,
  Box,
  Castle,
  Snowflake,
  Mountain,
} from "lucide-react";
import { Link } from "react-router-dom";

export const Attractions: React.FC = () => {
  const riwWahana = [
    {
      title: "Rabbit Castle",
      desc: "Istana megah bergaya Eropa dengan koloni kelinci langka yang siap menyambut.",
      icon: <Castle className="text-orange-500" />,
      color: "orange",
    },
    {
      title: "Giant Chess & Snow",
      desc: "Nikmati sensasi gelembung salju terbesar dan catur raksasa di tengah keramaian kelinci.",
      icon: <Snowflake className="text-cyan-500" />,
      color: "cyan",
    },
    {
      title: "Bukit Teletubbies",
      desc: "Area interaksi terbuka di hamparan bukit hijau dengan ratusan kelinci bebas berkeliaran.",
      icon: <Mountain className="text-emerald-500" />,
      color: "emerald",
    },
  ];

  const gizWahana = [
    {
      title: "Animasi 3D",
      desc: "Hewan digital interaktif yang hidup di dinding dan lantai dengan teknologi augmented reality.",
      icon: <Waves className="text-indigo-500" />,
      color: "indigo",
    },
    {
      title: "Rumah Balon",
      desc: "Ribuan bola bercahaya yang berubah warna saat berinteraksi fisik.",
      icon: <Box className="text-pink-500" />,
      color: "pink",
    },
    {
      title: "Hutan Menyala",
      desc: "Area hutan dengan pepohonan dan tanaman yang bersinar di kegelapan.",
      icon: <Zap className="text-yellow-500" />,
      color: "yellow",
    },
  ];

  const riwFeatures = [
    { title: "Public Space", desc: "Event & Aktivitas", icon: "🎪" },
    { title: "Meja Belajar", desc: "Pinjam & Belajar", icon: "🎒" },
    { title: "Playground", desc: "Area Bermain", icon: "🎡" },
    { title: "Gratis Sepeda", desc: "Min. 2 Cup Wortel", icon: "🚲" },
    { title: "Pistol Bubble", desc: "Gratis Pinjam", icon: "🫧" },
    { title: "Wonder Café", desc: "Area Kuliner", icon: "🥤" },
  ];

  return (
    <div className="pt-24 pb-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-riw-primary font-black uppercase tracking-[.3em] text-xs">
            The Attractions
          </span>
          <h1 className="text-4xl md:text-6xl font-black text-slate-900 mt-4 tracking-tighter">
            Wahana & Pengalaman
          </h1>
          <p className="text-slate-500 mt-6 max-w-2xl mx-auto text-lg leading-relaxed">
            Jelajahi setiap sudut keajaiban yang kami tawarkan. Dari teknologi
            AR hingga interaksi satwa nyata.
          </p>
        </div>

        {/* RIW Section */}
        <div className="mb-20">
          <div className="flex items-center gap-4 mb-10 border-l-[8px] border-riw-primary pl-6">
            <div className="p-3 bg-orange-50 rounded-2xl">
              <Rabbit className="w-8 h-8 text-riw-primary" />
            </div>
            <div>
              <h2 className="text-2xl md:text-3xl font-black text-slate-900 uppercase tracking-tighter">
                Rabbit In Wonderland
              </h2>
              <p className="text-slate-500 text-sm font-medium">
                Interaksi Langsung Penuh Keajaiban
              </p>
            </div>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-10">
            {riwWahana.map((w, i) => (
              <div
                key={i}
                className="bg-white p-8 rounded-[2.5rem] border border-slate-100 shadow-sm hover:shadow-xl transition-all hover:-translate-y-2 group"
              >
                <div
                  className={`w-14 h-14 rounded-2xl bg-${w.color}-50 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform`}
                >
                  {w.icon}
                </div>
                <h3 className="text-lg font-black text-slate-900 mb-3 uppercase tracking-tight">
                  {w.title}
                </h3>
                <p className="text-sm text-slate-500 leading-relaxed mb-6">
                  {w.desc}
                </p>
                <Link
                  to="/#book"
                  className="text-xs font-black uppercase text-riw-primary tracking-widest flex items-center gap-2 hover:gap-3 transition-all"
                >
                  Pesan Tiket{" "}
                  <div className="w-1.5 h-1.5 bg-riw-primary rounded-full"></div>
                </Link>
              </div>
            ))}
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
            {riwFeatures.map((feat, i) => (
              <div
                key={i}
                className="bg-orange-50/40 border border-orange-100 p-5 rounded-2xl hover:bg-white hover:shadow-lg hover:-translate-y-1 transition-all group text-center"
              >
                <div className="text-2xl mb-3 group-hover:scale-110 transition-transform">
                  {feat.icon}
                </div>
                <h5 className="font-black text-slate-900 text-[10px] uppercase tracking-widest mb-1">
                  {feat.title}
                </h5>
                <p className="text-[9px] text-slate-400 font-bold uppercase leading-tight">
                  {feat.desc}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* GIZ Section */}
        <div className="mb-24">
          <div className="flex items-center gap-4 mb-10 border-l-[8px] border-giz-primary pl-6">
            <div className="p-3 bg-indigo-50 rounded-2xl">
              <Zap className="w-8 h-8 text-giz-primary" />
            </div>
            <div>
              <h2 className="text-2xl md:text-3xl font-black text-slate-900 uppercase tracking-tighter">
                Glow Interactive Zoo
              </h2>
              <p className="text-slate-500 text-sm font-medium">
                Pusat Wisata Edukasi Digital Tercanggih
              </p>
            </div>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {gizWahana.map((w, i) => (
              <div
                key={i}
                className="bg-white p-8 rounded-[2.5rem] border border-slate-100 shadow-sm hover:shadow-xl transition-all hover:-translate-y-2 group"
              >
                <div
                  className={`w-14 h-14 rounded-2xl bg-${w.color}-50 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform`}
                >
                  {w.icon}
                </div>
                <h3 className="text-lg font-black text-slate-900 mb-3 uppercase tracking-tight">
                  {w.title}
                </h3>
                <p className="text-sm text-slate-500 leading-relaxed mb-6">
                  {w.desc}
                </p>
                <Link
                  to="/#book"
                  className="text-xs font-black uppercase text-giz-primary tracking-widest flex items-center gap-2 hover:gap-3 transition-all"
                >
                  Pesan Tiket{" "}
                  <div className="w-1.5 h-1.5 bg-giz-primary rounded-full"></div>
                </Link>
              </div>
            ))}
          </div>
        </div>

        <div className="mb-24">
          <div className="flex justify-between items-end mb-10">
            <div>
              <h2 className="text-3xl font-black text-slate-900 uppercase tracking-tighter">
                Galeri Keseruan
              </h2>
              <p className="text-slate-500 mt-2">
                Momen-momen tak terlupakan para pengunjung kami.
              </p>
            </div>
          </div>
          <Gallery />
        </div>
      </div>
    </div>
  );
};
